import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "module card-module" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "number-display" }
const _hoisted_5 = { class: "keypad" }

import "@style/modules/number-decoder.scss";
import ModuleStatusIndicator from "@src/components/ModuleStatusIndicator.vue";
import { ref } from "vue";
import Keycap from "@src/components/Keycap.vue";
import defineModuleState, {
  ModuleEmits,
  ModuleProps,
} from "@src/composables/defineModuleState";
import { DifficultyLevel } from "@src/helpers/difficultyLevelConstants";
import defineDebugState from "@src/composables/defineDebugState";
import SevenSegment from "@src/components/SevenSegment.vue";

enum NumberState {
  INCORRECT,
  CORRECT,
  PARTIAL,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NumberDecoderModule',
  props: ModuleProps,
  emits: ModuleEmits,
  setup(__props, { emit }) {

const props = __props;



const state = defineModuleState(props, emit);
const debugState = defineDebugState();

state.onArmed(armModule);
state.onReady(restartModule);
state.onFailed(freezeModule);

const DIFFICULTY_LEVELS = {
  [DifficultyLevel.EASY]: 3,
  [DifficultyLevel.AVERAGE]: 4,
  [DifficultyLevel.HARD]: 5,
  [DifficultyLevel.IMPOSSIBLE]: 6,
};

const NUMBER_OF_ATTEMPTS = {
  [DifficultyLevel.EASY]: 5,
  [DifficultyLevel.AVERAGE]: 9,
  [DifficultyLevel.HARD]: 5,
  [DifficultyLevel.IMPOSSIBLE]: 5,
};

const numberOfTries = ref(0);
const numbersInput = ref<string>("");
let maxNumbers: number = 0;
let numberToGuess: string = "";
let numbersState: Array<NumberState> = [
  NumberState.INCORRECT,
  NumberState.INCORRECT,
  NumberState.INCORRECT,
  NumberState.INCORRECT,
];
const strikeNumber = ref<number>(0);

function armModule(): void {
  maxNumbers = DIFFICULTY_LEVELS[props.difficulty];
  numberOfTries.value = 0;
  numberToGuess = generateNumberToGuess();
  initNumbersState();
}

function initNumbersState(): void {
  numbersState = [];
  for (let i = 0; i < maxNumbers; i++) {
    numbersState.push(NumberState.INCORRECT);
  }
}

function checkState(): boolean {
  for (let i = 0; i < numbersInput.value.length; i++) {
    if (numbersInput.value[i] === numberToGuess[i]) {
      numbersState[i] = NumberState.CORRECT;
    } else if (numberToGuess.includes(numbersInput.value[i])) {
      numbersState[i] = NumberState.PARTIAL;
    } else {
      numbersState[i] = NumberState.INCORRECT;
    }
  }
  if (numbersInput.value === numberToGuess) {
    state.emitDisarmed();
    numbersInput.value = "";
    return true;
  }

  numberOfTries.value++;

  if (numberOfTries.value > NUMBER_OF_ATTEMPTS[props.difficulty]) {
    if (
      strikeNumber.value > 1 ||
      props.difficulty === DifficultyLevel.IMPOSSIBLE
    ) {
      state.emitFailed();
    } else {
      strikeNumber.value++;
    }
  }

  return false;
}

function addNumberToInput(num: number): void {
  if (state.isArmed.value && numbersInput.value.length < maxNumbers) {
    numbersInput.value = numbersInput.value + num.toString();
  }
}

function submitInput(): void {
  if (state.isArmed.value && numbersInput.value.length === maxNumbers) {
    if (!checkState()) {
      numbersInput.value = "";
    }
  }
}

function restartModule(): void {
  numbersState = [
    NumberState.INCORRECT,
    NumberState.INCORRECT,
    NumberState.INCORRECT,
    NumberState.INCORRECT,
  ];
  numbersInput.value = "";
}

function freezeModule(): void {}

function generateNumberToGuess(): string {
  const num = "1234567890";
  const offset = Math.floor(Math.random() * 10);
  const offsetEnd = offset + maxNumbers;
  let sub = num.substring(offset, offset + maxNumbers);
  if (offsetEnd > num.length) {
    sub += num.substring(0, maxNumbers - sub.length);
  }

  sub = sub
    .split("")
    .map((value) => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value)
    .join("");

  return sub;
}

function getCharacter(index: number): string {
  if (index > maxNumbers - 1) {
    return "-";
  }
  if (numbersInput.value.length == 0) {
    if (numbersState[index] === NumberState.PARTIAL) {
      return "_";
    }
    if (numbersState[index] === NumberState.CORRECT) {
      return "c";
    }
  }
  const numericArray = numbersInput.value.split("");
  return numericArray[index] ?? "";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(debugState).isDebugModeEnabled.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(numberToGuess)) + " | " + _toDisplayString(numberOfTries.value) + " | " + _toDisplayString(strikeNumber.value), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (n, index) => {
          return _createVNode(SevenSegment, {
            class: "digit",
            character: getCharacter(index),
            width: 40,
            height: 60,
            padding: 7,
            "segment-size": 5
          }, null, 8 /* PROPS */, ["character"])
        }), 64 /* STABLE_FRAGMENT */))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(Keycap, {
          top: "0",
          left: "0",
          width: "60px",
          height: "60px",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (addNumberToInput(1)))
        }, {
          default: _withCtx(() => [
            _createTextVNode("1 ")
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(Keycap, {
          top: "0",
          left: "64px",
          width: "60px",
          height: "60px",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (addNumberToInput(2)))
        }, {
          default: _withCtx(() => [
            _createTextVNode("2 ")
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(Keycap, {
          top: "0",
          left: "128px",
          width: "60px",
          height: "60px",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (addNumberToInput(3)))
        }, {
          default: _withCtx(() => [
            _createTextVNode("3 ")
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(Keycap, {
          top: "64px",
          left: "0",
          width: "60px",
          height: "60px",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (addNumberToInput(4)))
        }, {
          default: _withCtx(() => [
            _createTextVNode("4 ")
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(Keycap, {
          top: "64px",
          left: "64px",
          width: "60px",
          height: "60px",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (addNumberToInput(5)))
        }, {
          default: _withCtx(() => [
            _createTextVNode("5 ")
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(Keycap, {
          top: "64px",
          left: "128px",
          width: "60px",
          height: "60px",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (addNumberToInput(6)))
        }, {
          default: _withCtx(() => [
            _createTextVNode("6 ")
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(Keycap, {
          top: "128px",
          left: "0",
          width: "60px",
          height: "60px",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (addNumberToInput(7)))
        }, {
          default: _withCtx(() => [
            _createTextVNode("7 ")
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(Keycap, {
          top: "128px",
          left: "64px",
          width: "60px",
          height: "60px",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (addNumberToInput(8)))
        }, {
          default: _withCtx(() => [
            _createTextVNode("8 ")
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(Keycap, {
          top: "128px",
          left: "128px",
          width: "60px",
          height: "60px",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (addNumberToInput(9)))
        }, {
          default: _withCtx(() => [
            _createTextVNode("9 ")
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(Keycap, {
          top: "128px",
          left: "192px",
          width: "60px",
          height: "60px",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (addNumberToInput(0)))
        }, {
          default: _withCtx(() => [
            _createTextVNode("0 ")
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(Keycap, {
          top: "0",
          left: "192px",
          width: "60px",
          height: "124px",
          class: "enter-key key-row-1 key-col-4",
          onClick: submitInput
        }, {
          default: _withCtx(() => [
            _createTextVNode("E ")
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _createVNode(ModuleStatusIndicator, {
      "is-armed": _unref(state).isArmed.value,
      "is-disarmed": _unref(state).isDisarmed.value,
      "strike-number": strikeNumber.value
    }, null, 8 /* PROPS */, ["is-armed", "is-disarmed", "strike-number"])
  ]))
}
}

})